import { useEffect, useState } from "react";
import { 
    Box, 
    Grid, 
    Typography,
    Tabs,
    Tab,
    Dialog
} from "@mui/material";
import { toast } from "react-toastify";
import BenefitCard from "../../../v2/Benefits/Beneficiary/Components/BenefitCard";
import FirmDetails from "../../../v2/Benefits/Beneficiary/Components/FirmDetails";
import { CustomButton } from "../../../v2/MUI_custom_component";
import StaffCard from "./Components/StaffCard";
import { AddStaffBeneficiaryNomineeAction, deleteStaffAction, getStaffInsuranceAction } from "./APIs/action";
import { useLocation } from "react-router-dom";
import StaffBeneficiaryNominee from "./Components/StaffBeneficiaryNominee";
import IllustrationWrapper from "../../Illustrration/IllustrationWrapper";
import DeleteSvg from '../../Illustrration/components/DeleteSvg';

const StaffInsurance = () => {
    const location = useLocation();
    const selectedCompanyEntity = location?.state?.selectedCompanyEntity || '';
    const [staffInsuranceData, setStaffInsuranceData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteContext, setDeleteContext] = useState(null); // { type: 'beneficiary' | 'nominee' }
    const [currentTab, setCurrentTab] = useState(0);
    const { benefit_card, selected_firm, staff_details, relations } = staffInsuranceData || {};

    const handleDeleteStaff = (deleteType = 'beneficiary') => {
        setDeleteContext({ type: deleteType });
        setDeleteDialogOpen(true);
    };
    const getStaffInsuranceData = async () => {
        setLoader(true);
        const {error, message, data} = await getStaffInsuranceAction(selectedCompanyEntity);
        setLoader(false);
        if (!error) {
            setStaffInsuranceData(data);
        } else {
            toast.error(message);
        }
    };

   
    const handleSaveBeneficiaryNominee = async(beneficiaryData, nomineeData ,staffData ) => {
          const payload ={
            company_esi_id: selectedCompanyEntity,
            staff_no: staffData.staff_no,
            beneficiary: {
                id_type: beneficiaryData.document_id ? 1 : null ,
                document_no: beneficiaryData.document_id || null,
                full_name: beneficiaryData.full_name,
                dob: beneficiaryData.dob,
                age: beneficiaryData.age,
                phone_number: beneficiaryData.phone_number,
                gender: beneficiaryData.gender ? beneficiaryData.gender.toUpperCase() : null,
                ocr_verified: beneficiaryData.ocr_verified || false,
            },
            nominee: {
                id_type: nomineeData.document_id ? 1 : null ,
                document_no: nomineeData.document_id || null,
                full_name: nomineeData.full_name,
                dob: nomineeData.dob,
                age: nomineeData.age,
                phone_number: nomineeData.phone_number,
                gender: nomineeData.gender ? nomineeData.gender.toUpperCase() : null,
                ocr_verified: nomineeData.ocr_verified || false,
                relation: nomineeData.relation || null,

            }
            
        }
        const { error, message } = await AddStaffBeneficiaryNomineeAction(payload);
        if (!error) {
            toast.success(message);
            getStaffInsuranceData()
        } else {
            toast.error(message);
        }
    };

    useEffect(() => {   
        getStaffInsuranceData();
    }, []);

    if (loader) {
        return (
            <Box sx={{ p: { xs: 1.5, md: 3 } }}>
                <Typography variant="body2" color="text.secondary">
                    Loading staff insurance details...
                </Typography>
            </Box>
        );
    }   

    return (
        <Box sx={{ p: { xs: 1.5, md: 3 } }}>
            <Grid container spacing={2} sx={{ alignItems: 'stretch', mb: 3 }}>
                <Grid item xs={12} sm={6}>
                    <BenefitCard item={benefit_card} sx={{ height: '100%' }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Box
                        sx={{
                            background: '#fff',
                            p: 2,
                            borderRadius: 2,
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-evenly',
                        }}
                    >
                        {selected_firm?.length > 0 ? (
                            selected_firm.map((detail, index) => (
                                <FirmDetails key={detail?.id || index} detail={detail} />
                            ))
                        ) : (
                            <Typography variant="body2" color="text.secondary">
                                No firm details available
                            </Typography>
                        )}
                    </Box>
                </Grid>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Box>
                        <Box>
                            {staff_details?.length > 0  && (
                                <Box>
                                    <Tabs 
                                        value={currentTab} 
                                        onChange={(event, newValue) => setCurrentTab(newValue)}
                                        sx={{ 
                                            borderBottom: 1, 
                                            borderColor: 'divider',
                                            mb: 3
                                        }}
                                        variant="scrollable"
                                        scrollButtons="auto"
                                    >
                                        {staff_details.map((staff, index) => (
                                            <Tab 
                                                key={staff.staff_no}
                                                label={staff.staff_label} 
                                                sx={{
                                                    textTransform: 'none',
                                                    fontWeight: 600,
                                                    fontSize: '13px',
                                                    minWidth: 62,
                                                }}
                                            />
                                        ))}
                                    </Tabs>
                                    {staff_details.map((staff, index) => (
                                        <Box
                                            key={staff.staff_no}
                                            role="tabpanel"
                                            hidden={currentTab !== index}
                                            sx={{ 
                                                display: currentTab === index ? 'block' : 'none' 
                                            }}
                                        >
                                            {currentTab === index && (
                                                <Box>
                                                    {(() => {
                                                        const hasValidBeneficiary = staff.beneficiary && 
                                                            Object.keys(staff.beneficiary).length > 0 && 
                                                            staff.beneficiary.full_name;
                                                        
                                                        if (!hasValidBeneficiary) {
                                                            return (
                                                                <StaffBeneficiaryNominee 
                                                                    staffData={staff}
                                                                    onSave={handleSaveBeneficiaryNominee}
                                                                    relations={relations}
                                                                    showManualEntry={false}
                                                                />

                                                            );
                                                        }
                                                        return (
                                                            <StaffCard
                                                                staffData={staff}
                                                                onDelete={handleDeleteStaff}
                                                                relations={relations}
                                                            />
                                                        );
                                                    })()}
                                                </Box>
                                            )}
                                        </Box>
                                    ))}
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Grid>
            </Grid>

             <Dialog 
                open={deleteDialogOpen} 
                onClose={() => {
                    setDeleteDialogOpen(false);
                    setDeleteContext(null);
                }}
                PaperProps={{
                    sx: { borderRadius: 2, textAlign: 'center',  width: 400, p: 2 , m: 0, gap: 4}
                }}
                >
                <Box sx={{ textAlign: 'center'}}>
                    <IllustrationWrapper 
                        illustration={<DeleteSvg />}
                        title={`Are you sure you want to delete the ${deleteContext?.type || 'staff'} details for ${staff_details?.[currentTab]?.staff_label || 'this staff member'}?`}
                        subtitle="This action cannot be undone. All data would be lost?"
                    />
                </Box>
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                    <CustomButton
                        variant="outlined"
                        color="primary"
                        label="No"
                        onClick={() => {
                                    setDeleteDialogOpen(false);
                                    setDeleteContext(null);
                                }}
                        sx={{ width: '100%' }}
                    />
                    <CustomButton
                        variant="filled"
                        color="primary"
                        label="Yes"
                        onClick={async () => {
                                    if (!deleteContext || !staff_details?.[currentTab]) return;
                                    
                                    const isBeneficiary = deleteContext.type === 'beneficiary';
                                    const isNominee = deleteContext.type === 'nominee';
                                    const staffNo = staff_details[currentTab].staff_no;
                                    
                                    setLoader(true);
                                    const response = await deleteStaffAction(isBeneficiary, isNominee, staffNo, selectedCompanyEntity);
                                    const { error, message } = response;
                                    setLoader(false);
                                    
                                    if (!error) {
                                        toast.success(message);
                                        await getStaffInsuranceData();
                                    } else {
                                        toast.error(message);
                                    }
                                    setDeleteDialogOpen(false);
                                    setDeleteContext(null);
                                }}
                        disabled={loader}
                        loading={loader}
                        sx={{ width: '100%' }}
                    />
                </Box>
            </Dialog>
        </Box>
    );
};

export default StaffInsurance;